interface Params {
  key: string;
}

/** Creates a standard query key set that can be easily used in useQuery and useMutation hooks */
export const createQueryKeySet = ({ key }: Params) => {
  const key_set = {
    /** Everthing for this key */
    all: [key] as const,

    /** All of the lists */
    lists: () => [...key_set.all, 'list'] as const,

    /** A specific list */
    list: <T>(params?: T) => [...key_set.lists(), params] as const,

    /** All of the pages for this key */
    all_pages: () => [...key_set.all, 'page'] as const,

    /** A specific set of pages */
    pages: <T>(params?: T) => [...key_set.all, 'page', params] as const,

    /** All of the single records */
    details: () => [...key_set.all, 'detail'] as const,

    /** An individual record */
    detail: (id?: string) => [...key_set.details(), id || 'unknown'] as const,
  };

  return key_set;
};

export type QueryKeySet = ReturnType<typeof createQueryKeySet>;
